import React, { useEffect, useState } from 'react';

import { productApi as api } from 'api/product';
import { DataTable, Notifications } from 'shared';

function ViewFeatureFlag() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'feature', Header: 'Feature Flag', editable: true },
        { accessor: 'enabled', Header: 'Enabled', editable: true, type: 'checkbox', editProps: { type: 'checkbox' } },
    ];

    const getFeatureFlag = async () => {
        const response = await api.getAssignableFeatureFlags();
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        getFeatureFlag();
    }, []);

    return (
        <div>
            <h1>Feature Flags</h1>
            <Notifications options={notification} />
            {}
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, row, value }) => {
                        const payload = field === 'feature' ? { name: value } : { [field]: value };
                        const res = await api.updateFeatureFlag(id, payload);
                        if (!res.status) {
                            setNotification({ text: res.msg, level: 'error' });
                            return false;
                        }

                        setNotification({ text: 'Flag updated', level: 'success' });
                        getFeatureFlag();
                        return true;
                    }}
                />
            </div>
        </div>
    );
}

export { ViewFeatureFlag };
